<template>
    <GeneralDialogTemplate @close="$emit('close')">
        <template slot="header">
            <span v-if="form_data.person_id" class="font-weight-medium">[{{ form_data.person_id }}] {{ form_data.name }}</span>
            <span v-else class="font-weight-medium">{{ ("Edit lead") }} {{ form_data.row_id }} </span>
        </template>
        <form>
            <v-row no-gutters>
                <v-col class="col-12 pa-2">
                    {{ form_data.email }}
                </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col class="col-12 pa-2">
                    <v-text-field
                        v-model="form_data.is_vip"
                        :label="('VIP')"
                        placeholder="1 or 0"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col class="col-12 pa-2">
                    <v-select
                        v-model="form_data.region"
                        :label="('Region')"
                        :items="regions"
                        outlined
                    ></v-select>
                </v-col>
            </v-row>

            <!-- TAGS -->
            <br>
            <v-row no-gutters>
                <v-col class="col-12 pa-2">
                    <text-area-field v-model="form_data.tags" :label="('Tags')" outlined/>
                </v-col>
            </v-row>
            <v-row no-gutters v-if="!!form_data.deleted_tags">
                <v-col class="col-12 pa-2">
                    <em>Deleted tags: {{ form_data.deleted_tags }}</em>
                </v-col>
            </v-row>

        </form>
        <template slot="footer">
            <v-spacer/>
            <v-btn color="primary" text @click="$emit('close')">
                {{ ("Cancel") }}
            </v-btn>
            <v-btn color="primary inverted--text" :loading="loading" class="px-5" @click="onSaveClick()">
                {{ ("Save") }}
            </v-btn>
        </template>
    </GeneralDialogTemplate>
</template>

<script>
import Vue from "vue"
import {computed, ref} from "@vue/composition-api"
import GeneralDialogTemplate from "../Dialog/GeneralDialogTemplate"
import AppModule from "../../store/modules/app"
import AccountModule from "../../store/modules/account"

export default {
    name: "AdminMemberDialog",
    components: {
        GeneralDialogTemplate
    },
    props: {
        payload: {
            type: Object,
            required: true
        },
    },
    setup(props, context) {
        const accountModule = AccountModule()
        const appModule = AppModule()
        const form_data = ref(null)
        const loading = false
        const regions = computed(function () {
            return ['ee', 'gb', 'pl', 'us', 'eu']
        })

        const load_data = function () {
            console.info('props.payload', props.payload)
            let data = {
                row_id: props.payload.row_id,
                user_id: props.payload.user_id,
                person_id: props.payload.person_id,
                region: props.payload.region,
                is_vip: props.payload.is_vip,
                first_name: props.payload.first_name,
                last_name: props.payload.last_name,
                name: props.payload.name,
                email: props.payload.email,
            }
            if (props.payload._data && 'tags' in props.payload._data) {
                data['tags'] = props.payload._data['tags'].join('\n')
            }
            if (props.payload._data && 'deleted_tags' in props.payload._data) {
                data['deleted_tags'] = props.payload._data['deleted_tags'].join(', ')
            }
            form_data.value = Vue.prepare_form_data(data)
        }

        const validate = function () {
            return true
        }
        const onSaveClick = function () {
            appModule.clearValidationErrors(form_data.value)
            if (!validate()) return

            let data = Vue.clean_and_clone_object(form_data.value)
            accountModule
                .saveAdminData(data['person_id'] ? 'person' : 'lead', data)
                .then(function () {
                    context.emit("close", data)
                })
                .catch(function (ex) {
                    appModule.handleErrorResponse(form_data.value, ex)
                })
        }

        load_data()

        return {
            form_data,
            loading,
            onSaveClick,
            regions,
        }
    }
}
</script>
